<template lang='pug'>
.fpui-preview-lightbox
  .fpui-preview-lightbox-wrapper
    i.fpui.fpui-remove.close-image.pointer(@click="$emit('close')")
    i.fpui.fpui-chevron-right.next-image.pointer(@click="nextImage")
    i.fpui.fpui-chevron-left.prev-image.pointer(@click="prevImage")
    transition-group(name='lightbox-fade')
      .lightbox(v-if="idx === active", v-for='image, idx in images')
        .content-lightbox(md-vertical-align="center", md-align="center")
          fpui-preview-lightbox-image(:src="image")
          .images-preview(md-align="center")
            .image-preview-content
              .image-content(
                :class="{active: active === index }",
                v-for="src, index in images",
                @click="$emit('open', index)"
              )
                img(:src="src")
</template>

<script>
import FpuiPreviewLightboxImage from './FpuiPreviewLightboxImage'

export default {
  components: { FpuiPreviewLightboxImage },
  props: {
    active: { type: Number, required: true },
    images: { type: Array, required: true }
  },
  computed: {
    image () { return this.images[this.active] }
  },
  mounted () {
    document.addEventListener('keyup', this.onKeyUp)
  },
  destroyed () {
    document.removeEventListener('keyup', this.onKeyUp)
  },
  methods: {
    nextImage () {
      let index = this.active + 1
      if (index >= this.images.length) {
        index = 0
      }
      this.$emit('open', index)
    },
    prevImage () {
      let index = this.active - 1
      if (index < 0) {
        index = this.images.length - 1
      }
      this.$emit('open', index)
    },
    onKeyUp (e) {
      switch (e.keyCode) {
        case 39: return this.nextImage()
        case 37: return this.prevImage()
        case 27: return this.$emit('close')
        default: break
      }
    }
  }
}
</script>

<style lang='less'>
  .lightbox-fade-enter-active, .lightbox-fade-leave-active {
    transition: opacity .5s;
  }

  .lightbox-fade-enter, .lightbox-fade-leave-active {
    opacity: 0;
  }

  .lightbox-enter-enter-active, .lightbox-enter-leave-active {
    transition: transform .5s;
  }

  .lightbox-enter-enter {
    opacity: 0;
    transform: translateX(100px);
  }

  .lightbox-enter-leave {
    opacity: 0;
    transform: translateX(-100px);
  }
  .fpui-preview-lightbox {
    z-index: 100;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color: rgba(0, 0, 0, 0.85);
    .fpui-preview-lightbox-wrapper {
      position: relative;
      height: 100%;
      width: 100%;
      .fpui {
        position:absolute;
        color: white;
        z-index: 3000;
        font-size: 40px;
        &.close-image {
          right: 20px;
          top: 20px;
        }
        &.next-image {
          right: 20px;
          top: 48%;
        }
        &.prev-image {
          left: 20px;
          top: 48%;
        }
      }
    }
    .lightbox {
      height: 100%;
      width: 100%;
      .content-lightbox {
        height: 100%;
        width: 100%;
        position:relative;
        .images-preview {
          position: fixed;
          bottom: 5px;
          left: 50%;
          transform: translateX(-50%);
          width: 80%;
          height: 60px;
          .image-preview-content {
            position: relative;
            width: 100%;
            white-space: nowrap;
            text-align:center;
            overflow: auto;
            overflow-y: hidden;
            height: 100%;
            .image-content {
              display: inline-block;
              cursor: pointer;
              img {
                opacity: 0.7;
                width: 60px;
                height: 60px;
              }
              &.active {
                img {
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
